import React, { useState, useEffect } from "react";
import { IconButton } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import { ReactComponent as CloseIcon } from "../../themes/Icons/close_icon.svg";
import { ReactComponent as SaveMood } from "../../assets/svg/save-mood.svg";
import {
  ContentModalActiveSurvey,
  CloseModalActiveSurvey,
  ModalFooter,
  GeneralContainer,
  CloseIconSvg,
  SaveMoodSvg,
} from "./MoodMeterContainer.styled";
import FeelingFaces from "../../components/MoodMeterBlock/FeelingFaces/FeelingFaces";
import FeelingOptions from "../../components/MoodMeterBlock/FeelingOptions/FeelingOptions";
import BtnFeelingFacesConfig from "../../components/MoodMeterBlock/BtnFeelingFacesConfig/BtnFeelingFacesConfig";
import { NotificationManager } from "react-notifications";
import { useMutation, useLazyQuery } from "@apollo/client";
import {
  ALL_SMILEYS,
  ALL_REASONS,
  ALL_DETAILS_BY_REASON_ID,
} from "../../GraphQL/Queries";
import { CREATE_USERS_FEELING } from "../../GraphQL/Mutations";
import { getStateLoginComplete } from "../LayoutHome/stateLogin";
import { useHistory } from "react-router-dom";
import { ROLES } from "../../util/RolesConstants";
import StepperLine from "../../components/StepperLine/StepperLine";
import { theme as themeConfig } from "../../themes/themes";
import PropTypes from "prop-types";

const MoodMeterContainer = ({
  setOpenMoodMeterModal,
  messageConfigAdmin,
  openConfigAdmin,
  setDaySaved,
  timeConfig,
  openMoodMeterModal,
  superVisorId,
  handleViewRequests,
  setMoodReceived,
}) => {
  const [createUsersFeeling] = useMutation(CREATE_USERS_FEELING);
  const [user] = useState(getStateLoginComplete());
  const history = useHistory();
  const [options, setOptions] = useState([]);
  const [optionsDetails, setOptionsDetails] = useState([]);
  const [faces, setFaces] = useState([]);
  const [comment] = useState("");
  const [checkMailingWellness, setCheckMailingWellness] = useState(false);
  const [checkMailingSupervisor, setCheckMailingSupervisor] = useState(false);
  const [faceSelect, setFaceSelect] = useState(0);
  const [optionResponse, setOptionResponse] = useState();
  const [detailResponse, setDetailResponse] = useState([]);
  const [stateSave, setStateSave] = useState(false);
  const [step, setSteps] = useState(1);

  const [runQueryAllReaseons, { loading: loadingReasons }] = useLazyQuery(
    ALL_REASONS,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        if (!data.allReasons.withError) {
          let reasons = data.allReasons.outputData.filter(
            (reasons) => reasons.recordState === "Active"
          );
          setOptions(reasons);
        } else {
          NotificationManager.error(data.allReasons.message, "", 5000);
        }
      },
    }
  );

  const [runQueryAllFaces, { loading: loadingFace }] = useLazyQuery(
    ALL_SMILEYS,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        if (!data.allSmileys.withError) {
          let allFaces = data.allSmileys.outputData
            .filter((f) => f.recordState === "Active")
            .map((item) => ({ ...item }));
          allFaces = arrangeSmileyByCategory(allFaces);
          setFaces([...allFaces]);
        } else {
          NotificationManager.error(data.allSmileys.message, "", 5000);
        }
      },
    }
  );

  const [runQueryAllDetailsByReasonId, { loading: loadingDetail }] =
    useLazyQuery(ALL_DETAILS_BY_REASON_ID, {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        if (!data.allDetailsByReasonId.withError) {
          let details = data.allDetailsByReasonId.outputData.filter(
            (detail) => detail.recordState === "Active"
          );
          setOptionsDetails(details);
        } else {
          NotificationManager.error(
            data.allDetailsByReasonId.message,
            "",
            5000
          );
        }
      },
    });

  useEffect(() => {
    runQueryAllFaces();
  }, []);

  useEffect(() => {
    if (faceSelect) {
      runQueryAllReaseons();
    }
  }, [faceSelect]);

  const handleOptionByReason = (option) => {
    if (option) {
      setOptionResponse(option);
    } else {
      setOptionResponse();
    }

    setDetailResponse([]);

    /*runQueryAllDetailsByReasonId({
      variables: {
        reasonId: option,
      },
    });*/
  };

  const arrangeSmileyByCategory = (data) => {
    return data.sort((a, b) => {
      return a.category - b.category;
    });
  };

  const handleOptionByDetails = (detalis) => {
    let detalisSelect = [];

    detalis.forEach((element) => {
      detalisSelect.push(element);
    });

    setDetailResponse(detalisSelect);
    // setSteps(3)
  };

  const saveMoodMeter = (reasonId) => {
    setStateSave(true);
    createUsersFeeling({
      variables: {
        idSmiley: faceSelect.idSmiley,
        idReason: reasonId,
        mailingWellness: checkMailingWellness,
        mailingSupervisor: checkMailingSupervisor,
      },
    }).then(
      (saveResponse) => {
        setStateSave(false);
        if (!saveResponse.data.createUsersFeeling.withError) {
          setDaySaved(new Date());
          setSteps(4);
          setMoodReceived(true);
        } else {
          let errorMessage = `${saveResponse?.data?.createUsersFeeling?.message}`;
          NotificationManager.error(errorMessage, "", 5000);
          setOpenMoodMeterModal(false);
        }
      },
      (error) => {
        setStateSave(false);
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      }
    );
  };
  const handleBackFeelingOptions = () => {
    setFaceSelect();
    setSteps(1);
  };

  const handleMoodMeterSettings = () => {
    setOpenMoodMeterModal(false);
    history.push({
      pathname: "/MoodMeterSettings",
    });
  };

  const areFewCheckboxes = optionsDetails?.length <= 2;

  return (
    <>
      {loadingFace || loadingReasons || loadingDetail || stateSave}
      <GeneralContainer>
        {openMoodMeterModal && (
          <span
            className="arrow-up"
            style={{
              position: "absolute",
              top: "-31px",
              right: "19.5%",
              zIndex: "4",
            }}
          ></span>
        )}
        <ContentModalActiveSurvey>
          <CloseModalActiveSurvey>
            {(user.roleId === ROLES.GAM ||
              user.roleId === ROLES.SUPER_ADMIN ||
              user.roleId === ROLES.COUNTRY_ADMIN ||
              user.roleId === ROLES.WELLNESS_PROFESSIONAL) && (
                <BtnFeelingFacesConfig
                  handleMoodMeterSettings={handleMoodMeterSettings}
                ></BtnFeelingFacesConfig>
              )}
            <Tooltip title="close">
              <IconButton
                className="align-right close"
                onClick={() => setOpenMoodMeterModal(false)}
              >
                <CloseIconSvg>
                  <CloseIcon />
                </CloseIconSvg>
              </IconButton>
            </Tooltip>
          </CloseModalActiveSurvey>
          <>
            {openConfigAdmin && step === 1 && (
              <FeelingFaces
                title="How are you feeling today?"
                faces={faces}
                faceSelect={faceSelect}
                setFaceSelect={setFaceSelect}
                handler={() => setSteps(2)}
                type='modal'
              ></FeelingFaces>
            )}
            {step === 1 &&
              (user.roleId === ROLES.SUPER_ADMIN ||
                user.roleId === ROLES.GAM ||
                user.roleId === ROLES.COUNTRY_ADMIN ||
                user.roleId === ROLES.WELLNESS_PROFESSIONAL) && (
                <div className="content-request-button">
                  <button
                    className="view-request-button"
                    onClick={() => {
                      handleViewRequests(false, "moodmeter"); // opens request dialog
                      setOpenMoodMeterModal(false);
                    }}
                  >
                    View requests
                  </button>
                </div>
              )}
            {(user.roleId === ROLES.AGENT || user.roleId === ROLES.GAM ||
              user.roleId === ROLES.SUPER_ADMIN || user.roleId === ROLES.COUNTRY_ADMIN ||
              user.roleId === ROLES.WELLNESS_PROFESSIONAL) &&
              !openConfigAdmin &&
              step !== 4 && (
                <div className="mood-meter_disabled">
                  <SaveMoodSvg>
                    <SaveMood />
                  </SaveMoodSvg>
                  <h6
                    style={{
                      margin: "1em",
                      fontWeight: "600",
                      textAlign: "center",
                      color: themeConfig.text.primary,
                      fontSize: "14px",
                    }}
                  >
                    {messageConfigAdmin}
                  </h6>
                </div>
              )}
          </>
          {(step === 2 || step === 3) && (
            <div>
              <FeelingOptions
                title={timeConfig?.questionForUser}
                options={options}
                faceSelect={faceSelect}
                backTOParent={handleBackFeelingOptions}
                handleOption={handleOptionByReason}
                optionsDetails={optionsDetails}
                handleOptionDetails={handleOptionByDetails}
                detailTitle="Could you tell us the main reason why?"
                selectedReason={optionResponse}
                selectedDetailedReason={detailResponse}
                setCheckMailingWellness={setCheckMailingWellness}
                setCheckMailingSupervisor={setCheckMailingSupervisor}
                checkMailingWellness={checkMailingWellness}
                checkMailingSupervisor={checkMailingSupervisor}
                handleNext={saveMoodMeter}
                updateStepper={setSteps}
                superVisorId={superVisorId}
                isSaving={stateSave}
              ></FeelingOptions>
            </div>
          )}
          {step === 4 && (
            <>
              <div className="save-mood">
                <SaveMoodSvg>
                  <SaveMood />
                </SaveMoodSvg>
                <div className="save-mood_info">
                  <strong
                    style={{
                      fontWeight: 700,
                      fontSize: "22px",
                      color: themeConfig.text.primary,
                    }}
                  >
                    Done
                  </strong>
                  <br />
                  {faceSelect?.category <= 3 && (
                    <>
                      <span
                        style={{
                          fontWeight: 400,
                          fontSize: "16px",
                          color: themeConfig.text.primary,
                        }}
                      >
                        Thank you for sharing your mood..
                      </span>
                      <br />
                    </>
                  )}
                </div>
              </div>
              <ModalFooter>
                <hr />
                <br />
                <br />
              </ModalFooter>
            </>
          )}
          {!messageConfigAdmin && <StepperLine activeStep={step}></StepperLine>}
        </ContentModalActiveSurvey>
      </GeneralContainer>
    </>
  );
};

export default MoodMeterContainer;

MoodMeterContainer.propTypes = {
  setOpenMoodMeterModal: PropTypes.func,
  messageConfigAdmin: PropTypes.string,
  openConfigAdmin: PropTypes.bool,
  setDaySaved: PropTypes.func,
  timeConfig: PropTypes.object,
  openMoodMeterModal: PropTypes.bool,
  superVisorId: PropTypes.number,
  handleViewRequests: PropTypes.func,
  setMoodReceived: PropTypes.func,
}
